import React, { useState } from 'react';
import logo from "./logondt.png";
import fb from "./image/L1 (1).svg";
import inst from "./image/L1 (2).svg";
import Ln from "./image/L1 (3).svg";
import {Link } from 'react-router-dom';
import { NavLink } from 'react-router-dom';


import Swal from 'sweetalert2';

export default function Preheader() {



      
  return (
    <>
      <div className="container-fluid nav-container">
        <div className="row">
          <div className="col-11">
           <Link to="/"> <img src={logo} className="logo" /></Link>
          </div>
          <div className="col-111">
            <div className="preheader d-flex mnone d-sm-none d-md-none d-xl-block d-xxl-block d-xs-none">
              {/* <div class="marquee"> */}
              
                <p className='text-center'>Catch us playing live on 3rd Aug - 31st Aug on Star Sports and Jio-Hostar. &nbsp; &nbsp; &nbsp;| &nbsp; &nbsp; &nbsp; Stay tuned on instagram handle @newdelhitigers for latest updates!</p>
              {/* </div> */}
             
            </div>
            <nav className="navbar navbar-expand-lg navbar-dark bg-coko">
            <Link to="/">  <img src={logo} className="logo1 d-none" /></Link>
              <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav mr-auto">
      <li className="nav-item">
        <NavLink exact className="nav-link" activeClassName="active" to="/">
          Home
        </NavLink>
      </li>
      <li className="nav-item">
        <NavLink className="nav-link" activeClassName="active" to="/about-us">
          About Us
        </NavLink>
      </li>
      <li className="nav-item">
        <NavLink className="nav-link" activeClassName="active" to="/squad">
          Squad
        </NavLink>
      </li>
      {/* <li className="nav-item">
        <a className="nav-link" href="#matches">
          Matches
        </a>
      </li> */}
      <li className="nav-item">
        <NavLink className="nav-link" activeClassName="active" to="/standing">
          Standings
        </NavLink>
      </li>
      {/* <li className="nav-item">
        <NavLink className="nav-link" activeClassName="active" to="/news">
          News
        </NavLink>
      </li> */}
      <li className="nav-item">
        <NavLink className="nav-link" activeClassName="active" to="/auction">
          Auction
        </NavLink>
      </li>

      <li className="nav-item">
        <NavLink className="nav-link" activeClassName="active" to="/video">
          Videos
        </NavLink>
      </li>
      {/* <li className="nav-item">
        <button  data-toggle="modal" data-target="#exampleModalCenter" class="button-33 sponsorbtn" role="button">Sponsorship </button>

      </li> */}
    </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>



  
</>
  )
}
